import { Component, OnInit } from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import { AuthenicationService } from '../../_services/authenication.service';
import { VentoutwallService } from '../../_services/ventoutwall.service';
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';


declare var $: any;

@Component({
  selector: 'app-walllcategories',
  templateUrl: './walllcategories.component.html',
  styleUrls: ['./walllcategories.component.css']
})
export class WalllcategoriesComponent implements OnInit {

  editCatForm: FormGroup;
  categorieslist: [];
  userdetaild: string;
  submitted = false;
  wall_id: string;
  active:boolean;
  returnUrl: string;
  baseUrl: string = environment.baseUrl;

  constructor(private formBuilder: FormBuilder, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private ventoutwallservice: VentoutwallService, private toaster: ToasterService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.editCatForm = this.formBuilder.group({
      wall_cat_title: ['', [Validators.required, Validators.minLength(3)]],
      wall_cat_status: ['true', [Validators.required]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.categoriesList();
  }

  get f() { return this.editCatForm.controls; }

  categoriesList() {
    this.ventoutwallservice.getCategoriesList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.categorieslist = data.DiscussionList;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Categories', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Categories', error.error.ResponseMessage);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deleteCategories(id){
    this.ventoutwallservice.deleteCategory(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
            this.categoriesList();
          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error.error.ResponseMessage);
        });
  }

  editForm(data: any) {
    this.wall_id = data._id;
    this.active = data.wall_cat_status;
    this.editCatForm.setValue({
      wall_cat_title: data.wall_cat_title,
      wall_cat_status: data.wall_cat_status
    })
  }

  onSubmit() {
    if (this.editCatForm.invalid) {
      return;
    }
    const catPayload = {
      wall_cat_title: this.editCatForm.controls.wall_cat_title.value,
      wall_cat_status: this.editCatForm.controls.wall_cat_status.value,
      wall_id: this.wall_id
    };

    this.ventoutwallservice.editCategory(catPayload)
      .subscribe((data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Update', data.ResponseMessage);
            this.categoriesList();
            $('#ordine').modal('hide');
          } else {
            this.toaster.showError('Update', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Update', error.error.ResponseMessage);
        })
  };

}
